// HIGH SPEED SHOP — Recently Viewed Products
import { storeUrl } from './hs_utils';

const STORAGE_KEY = 'hs_recently_viewed';
const MAX_ITEMS = 12;

export function initRecentlyViewed() {
	trackProductView();
	renderRecentlyViewed();
}

function trackProductView() {
	const btn = document.querySelector('.hs-btn-add-cart[data-item-code]');
	const title = document.querySelector('.hs-pdp-title');
	if (!btn || !title) return;

	const itemCode = btn.dataset.itemCode;
	if (!itemCode) return;

	let viewed = getViewed();
	viewed = viewed.filter(code => code !== itemCode);
	viewed.unshift(itemCode);
	viewed = viewed.slice(0, MAX_ITEMS);
	localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
}

function getViewed() {
	try {
		return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
	} catch (e) {
		return [];
	}
}

function renderRecentlyViewed() {
	const containers = document.querySelectorAll('.hs-recently-viewed-container');
	if (!containers.length) return;

	let viewed = getViewed();

	// On PDP, exclude current item
	const btn = document.querySelector('.hs-btn-add-cart[data-item-code]');
	if (btn) {
		viewed = viewed.filter(code => code !== btn.dataset.itemCode);
	}

	if (!viewed.length) return;

	const codes = viewed.slice(0, 8);

	frappe.call({
		method: 'high_speed_shop.high_speed_shop.api.catalog.get_products_by_codes',
		args: { item_codes: codes },
		async: true,
		callback: function (r) {
			if (!r.message || !r.message.length) return;

			// Sort to match viewed order
			const map = {};
			r.message.forEach(item => { map[item.item_code] = item; });
			const ordered = codes.map(code => map[code]).filter(Boolean);

			if (!ordered.length) return;

			containers.forEach(container => {
				container.innerHTML = ordered.map(item => buildCard(item)).join('');
				const section = container.closest('.hs-recently-viewed-section');
				if (section) section.style.display = '';
			});
		},
	});
}

function buildCard(item) {
	const imgHtml = item.image
		? `<img src="${item.image}" alt="${esc(item.item_name)}" class="hs-product-image" loading="lazy">`
		: `<div class="hs-product-image hs-product-no-image">
			<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--hs-text-muted)" stroke-width="1">
				<rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
				<circle cx="8.5" cy="8.5" r="1.5"/>
				<polyline points="21 15 16 10 5 21"/>
			</svg>
		</div>`;

	const badge = item.custom_hs_badge_label
		? `<span class="hs-badge hs-badge-${(item.custom_hs_badge_color || 'blue').toLowerCase()}">${esc(item.custom_hs_badge_label)}</span>`
		: '';

	const oos = (item.in_stock !== undefined && !item.in_stock)
		? `<div class="hs-product-overlay-oos"><span>${__('Out of Stock')}</span></div>`
		: '';

	const category = item.item_group
		? `<span class="hs-product-category">${esc(item.item_group)}</span>`
		: '';

	let priceRow = '';
	if (item.formatted_price) {
		const mrp = (item.formatted_mrp && item.formatted_mrp !== item.formatted_price)
			? `<span class="hs-product-mrp">${item.formatted_mrp}</span>`
			: '';
		priceRow = `<div class="hs-product-price-row"><span class="hs-product-price">${item.formatted_price}</span>${mrp}</div>`;
	}

	const lowStock = item.low_stock
		? `<span class="hs-stock-badge hs-stock-low">${__('Low Stock')}</span>`
		: '';

	const oosClass = (item.in_stock !== undefined && !item.in_stock) ? ' hs-product-oos' : '';
	const disabled = (item.in_stock !== undefined && !item.in_stock) ? ' disabled' : '';
	const btnLabel = (item.in_stock !== undefined && !item.in_stock) ? __('Out of Stock') : __('Add to Cart');

	return `<div class="hs-product-card${oosClass}">
		<a href="${storeUrl('/product/' + item.item_code)}" class="hs-product-link">
			<div class="hs-product-image-wrap">
				${imgHtml}${badge}${oos}
			</div>
			<div class="hs-product-info">
				${category}
				<h3 class="hs-product-name">${esc(item.item_name || item.name)}</h3>
				${priceRow}
				${item.avg_rating ? `<div class="hs-card-rating"><svg width="14" height="14" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg> <span>${item.avg_rating}</span> <span class="hs-card-rating-count">(${item.rating_count})</span></div>` : ''}
				${lowStock}
			</div>
		</a>
		<div class="hs-product-actions">
			<button class="hs-btn hs-btn-primary hs-btn-add-cart" data-item-code="${item.item_code}"${disabled}>
				<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
					<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
					<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
				</svg>
				${btnLabel}
			</button>
		</div>
	</div>`;
}

function esc(str) {
	if (!str) return '';
	const d = document.createElement('div');
	d.textContent = str;
	return d.innerHTML;
}
